var RwAjaxHtml = (function () {

  // Inietta Html restituito dal file inc/moduli/func-ajax-html.php
  // La security è definita in inc/enqueue.php da rw_ajax_obj
  var news_modal = function () {

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_news',
        security : rw_ajax_obj.ajax_nonce,
      },
      beforeSend: function() {
        console.log('avviato ajax news');
      },
      success : function( response ) {

        $('#news-modal .modal-body').html( response );

      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){

        $('#news-modal').modal();

      }
    });

  };

  var news = function () {
    news_modal();
  };


  return {
    news : news
  }


})();
